
















































import '../../styles/add-adminuser-modal.css'
import Vue from 'vue'
import Modal from '../general/modal/Modal.vue'
import ModalBody from '../general/modal/ModalBody.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilX } from '@coreui/icons-pro'
import { IValidationResult } from '../../util/IValidationResult'

export default Vue.extend({
  name: 'AddAdminUserModal',
  data() {
    return {
      errors: [] as IValidationResult[],
      loading: false,
      selectedItem: { contactEmail: '' },
      exitIcon: cilX,
      items: [],
      search: '',
    }
  },
  components: { CIcon, Modal, ModalBody },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    close: function () {
      this.$emit('close')
    },
    add: async function () {
      await fetch('/api/PortalAdmin/Users', {
        method: 'POST',
        body: JSON.stringify({
          email: this.selectedItem.contactEmail,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
      this.$emit('close')
    },
  },
  watch: {
    async search(val) {
      if (!val) return
      if (val.length < 3) return

      if (this.loading) return

      this.loading = true
      try {
        this.items = await (
          await fetch(`/api/PortalAdmin/Users/Search?term=${val}`)
        ).json()
      } finally {
        this.loading = false
      }
    },
  },
})
